module.exports = __webpack_public_path__ + "static/media/10s.569ecb5d.png";